import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import _ from 'lodash';
import { Upload, Button } from 'antd';
import { UploadOutlined } from '@ant-design/icons';

import './WUpload.module.scss';
import { API_HOST } from 'configs/env';

//多檔案上傳
@connect(({ app = {}, user = {}, badges = {} }) => ({ app, user, badges }))
export default class WUpload extends Component {
  state = {
    fileList: [
      //   {
      //   uid: '-1',
      //   name: 'xxx.png',
      //   status: 'done',
      //   url: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png',
      // }
    ],
  };

  componentWillReceiveProps(nextProps) {
    const { fileList } = nextProps;
    if (Array.isArray(fileList)) {
      const { fileList: currentFileList } = this.state;

      fileList.forEach((file, idx) => {
        if (!file.uid && file.id) file.uid = file.id;
        if (!file.uid) file.uid = `uid-${idx}`;
      });

      if (fileList.length !== currentFileList.length) {
        this.setState({ fileList: fileList });
        return true;
      }

      var needUpdate = false;

      fileList.forEach((file, idx) => {
        if (file.uid !== fileList[idx].uid) {
          needUpdate = true;
        }
      });

      if (needUpdate === true) {
        this.setState({ fileList: fileList });
        return true;
      }
    }
  }

  render() {
    const {
      accept,
      beforeUpload,
      fileList,
      listType,
      multiple,
      name,
      showUploadList,
    } = this.props;

    return (
      <Fragment>
        <Upload
          action={`${API_HOST}/api/v1/system/image`}
          accept={accept}
          name={name}
          listType={listType}
          fileList={fileList}
          showUploadList={showUploadList}
          multiple={multiple}
          beforeUpload={beforeUpload}
          customRequest={(options) => {
            const data = new FormData();
            data.append('image', options.file);
            const config = {
              headers: {
                'Access-Token':
                  'e48b30e97cb3e6f9138ffb385e28531c83585069c5d5f54813cc1252c8540ccb',
                'content-type':
                  'multipart/form-data; boundary=----WebKitFormBoundaryqTqJIxvkWFYqvP5s',
              },
              onUploadProgress: function(progressEvent) {
                options.onProgress(
                  {
                    percent: (progressEvent.loaded / progressEvent.total) * 100,
                  },
                  options.file
                );
                // Do whatever you want with the native progress event
              },
            };
            options.onProgress({ percent: 0 }, options.file);
            axios
              .post(`${API_HOST}/api/v1/system/image`, data, config)
              .then((res) => {
                const { code = 100, reason = '未知錯誤', data = {} } = res.data;

                if (code !== 200) {
                  options.onError(new Error());
                  return;
                }

                const fileList = _.get(this, 'state.fileList', []);
                let file = _.find(
                  fileList,
                  (item) => item.uid === options.file.uid
                );

                if (file) {
                  file.path = data.path;
                  file.url = data.url;
                }

                if (this.props.onChange) {
                  this.props.onChange(fileList);
                }

                this.setState({ fileList }, () => {
                  options.onSuccess(res.data);
                });
              })
              .catch((error) => {
                let res = {
                  code: 200,
                  reason: '未知錯誤',
                  error: error,
                  data: {},
                };

                if (error.response) {
                  res.code = error.response.status;
                  res.reason = error.response.data.reason;
                }
                options.onError(error);
              });
          }}
          onChange={({ file, fileList, event }) => {
            if (this.props.onChange) {
              this.props.onChange(fileList);
            }
          }}
        >
          {this.props.children}
        </Upload>
      </Fragment>
    );
  }
}
// 單張圖片上傳
export class AvatarUpload extends Component {
  render() {
    const fileList = this.props.value ? [this.props.value] : [];
    return (
      <div style={{ minHeight: 102 }}>
        <WUpload
          name={this.props.name}
          listType='picture-card'
          className='avatar-uploader'
          fileList={fileList}
          onChange={(fileList) => {
            if (this.props.onChange) {
              this.props.onChange(_.last(fileList));
            }
          }}
        >
          {fileList.length >= 1 ? null : (
            <Button type='link'>
              <UploadOutlined /> 上傳
            </Button>
          )}
        </WUpload>
      </div>
    );
  }
}

// 單檔上傳



// WEBPACK FOOTER //
// ./src/components/WUpload/WUpload.js